// statistics

function main(){
	let store = window.localStorage[ 'GLB_STATISTICS_' + this.$Glb.getAttribute().pathName.toUpperCase() ];
	let initStore = ()=> {
		window.localStorage[ 'GLB_STATISTICS_' + this.$Glb.getAttribute().pathName.toUpperCase() ] = new Date().getTime().toString()
	}
	if( store ){
		if( (new Date().getTime() - store)<(24*60*60*1000) ){
			return 0
		}else{
			initStore()
			return 1
		}
		return 0	
	}else{
		initStore()
		return 1
	}
}

export default main



// WEBPACK FOOTER //
// ./src/utils/statistics.js